(function () {
  function removeDeliveryTimeLines(root) {
    var scope = root || document;
    scope.querySelectorAll('.product__description li, .product__description p').forEach(function (element) {
      if (/lieferzeit/i.test(element.textContent)) {
        element.remove();
      }
    });
  }

  function enhanceFeatureLists(root) {
    var description = (root || document).querySelector('.product__description');
    if (!description || description.dataset.simpleFitnessLayoutReady === 'true') return;

    var children = Array.from(description.children);
    var idealHeading = children.find(function (element) {
      return /^ideal für:?$/i.test(element.textContent.trim());
    });
    var idealList = idealHeading && idealHeading.nextElementSibling;
    var featureHeading = idealList && idealList.nextElementSibling;
    var featureList = featureHeading && featureHeading.nextElementSibling;

    if (idealHeading && idealList && idealList.tagName === 'UL' && featureHeading && /^merkmale:?$/i.test(featureHeading.textContent.trim()) && featureList && featureList.tagName === 'UL') {
      var grid = document.createElement('div');
      grid.className = 'simple-fitness-feature-grid';
      var idealColumn = document.createElement('section');
      idealColumn.className = 'simple-fitness-feature-column';
      var featureColumn = document.createElement('section');
      featureColumn.className = 'simple-fitness-feature-column';

      var insertBefore = idealHeading;
      description.insertBefore(grid, insertBefore);
      idealColumn.appendChild(idealHeading);
      idealColumn.appendChild(idealList);
      featureColumn.appendChild(featureHeading);
      featureColumn.appendChild(featureList);
      grid.appendChild(idealColumn);
      grid.appendChild(featureColumn);
    }

    description.dataset.simpleFitnessLayoutReady = 'true';
  }

  function enhanceProductPage(root) {
    removeDeliveryTimeLines(root);
    enhanceFeatureLists(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceProductPage(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    enhanceProductPage(event.target);
  });
})();
